import { Button } from 'components';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import { useAnalytics } from 'analytics';
import { ANALYTICS_EVENTS } from 'analytics/events';
import { useTranslation } from 'react-i18next';

interface ResultFeedbackSectionProps {
  onOpenFeedback: (isHelpful: boolean) => void;
  lastSubmittedHelpful?: boolean;
}

export function ResultFeedbackSection({
  onOpenFeedback,
  lastSubmittedHelpful,
}: ResultFeedbackSectionProps) {
  const { t } = useTranslation();
  const { trackEvent } = useAnalytics();

  const handleClick = (isHelpful: boolean) => {
    trackEvent(ANALYTICS_EVENTS.FEEDBACK_BUTTON_CLICKED, {
      source: 'result_inline',
      isHelpful,
    });
    onOpenFeedback(isHelpful);
  };

  return (
    <section className="mt-4 rounded-lg border border-border px-4 py-1 flex items-center justify-between">
      <p className="text-sm text-foreground">{t('result.feedback.questionShort')}</p>
      {lastSubmittedHelpful === undefined ? (
        <div className="flex items-center ">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={() => handleClick(true)}
            className="border-border"
            aria-label={t('result.feedback.yes')}
            data-ph-no-autocapture
          >
            <ThumbsUp className="h-4 w-4" />
          </Button>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={() => handleClick(false)}
            className="border-border"
            aria-label={t('result.feedback.no')}
            data-ph-no-autocapture
          >
            <ThumbsDown className="h-4 w-4" />
          </Button>
        </div>
      ) : (
        <div className="flex items-center">
          <div
            className={`flex h-8 w-8 items-center justify-center rounded-full ${
              lastSubmittedHelpful ? 'bg-emerald-500 text-white' : 'bg-destructive text-white'
            }`}
          >
            {lastSubmittedHelpful ? (
              <ThumbsUp
                role="status"
                aria-label={t('result.feedback.ratedHelpful')}
                className="h-4 w-4"
              />
            ) : (
              <ThumbsDown
                role="status"
                aria-label={t('result.feedback.ratedNotHelpful')}
                className="h-4 w-4"
              />
            )}
          </div>
        </div>
      )}
    </section>
  );
}
